import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          column
        >
          <CFView mt="5%" column alignCenter justifyEnd w="100%" textCenter>
            <CFImage
              w="70%"
              src={mobileHeroText}
              alt="Sushi Ru Victoria hero text"
              zIndex={98}
            />
            <CFView pulsate mt="10px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="650px"
          w="100%"
          image={`url(${hero}) center / cover no-repeat`}
          zIndex={90}
          column
          justifyCenter
          alignStart
        >
          <CFView column justifyCenter alignStart ml="5%">
            <CFImage
              w="480px"
              src={heroText}
              alt="Sushi Ru Victoria hero text"
              zIndex={98}
            />
            <CFView pulsate mt="35px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
